import parcel_point_icon from "./../assets/images/parcel_point_icon.png";
import locker_icon from "./../assets/images/locker_icon.png";
import door_icon from "./../assets/images/door_icon.png";

const servicesSelection = [
    {
        'text': 'Point',
        'value': 'pp',
        'icon': parcel_point_icon,
        'color': 'bg-[#1D2953]',
    },
    {
        'text': 'Locker',
        'value': 'locker',
        'icon': locker_icon,
        'color': 'bg-[#F2BA56]',
    },
    {
        'text': 'Kiosk',
        'value': 'kiosk',
        'icon': locker_icon,
        'color': 'bg-[#E5854A]',
    },
    {
        'text': 'Door',
        'value': 'door',
        'icon': door_icon,
        'color': 'bg-[#6EA3D5]',
    }
]

export default servicesSelection;